// removed by extract-text-webpack-plugin
module.exports = {"buttonGroup":"DurationRadio__buttonGroup___22t0h","radio":"DurationRadio__radio___3jvUt","radioContainer":"DurationRadio__radioContainer___1YhCQ","circle":"DurationRadio__circle___2Fxnr","active":"DurationRadio__active___3TVma","text":"DurationRadio__text___CiXKb"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/employer/project/components/DurationRadio.scss
// module id = 1931
// module chunks = 0